module.exports = __webpack_public_path__ + "static/joshua-tree-zoom-7525126d3beb96dd3edad359a6e923b1.jpg";